import { render, staticRenderFns } from "./TblDHR.vue?vue&type=template&id=f3bd7dd0&scoped=true&"
import script from "./TblDHR.vue?vue&type=script&lang=js&"
export * from "./TblDHR.vue?vue&type=script&lang=js&"
import style0 from "./TblDHR.vue?vue&type=style&index=0&id=f3bd7dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bd7dd0",
  null
  
)

export default component.exports